import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, ViewChild, WritableSignal, computed, signal } from '@angular/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { DialogService } from 'src/app/core/services/dialog.service';
import { PageComponent } from 'src/app/layout/pages/page/page.component';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { FilesizePipe } from 'src/app/core/pipes/filesize.pipe';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { GoogleMap, GoogleMapsModule, MapInfoWindow, MapMarker } from '@angular/google-maps';
import { PuntiCampionamentoService } from '../../punti-campionamento/punti-campionamento.service';
import { WaterSupplyZoneService } from '../water-supply-zone.service';
import { CardComponent } from "../../../shared/components/cards/card/card.component";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { InputTextComponent } from "../../../shared/components/inputs/input-text/input-text.component";
import { SnackbarService } from 'src/app/core/services/snackbar.service';
import { MatTabsModule } from '@angular/material/tabs';
import {MatStepperModule} from '@angular/material/stepper';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { wktToGeoJSON } from "@terraformer/wkt";
import * as Terraformer from "terraformer-wkt-parser";
import { MyDialogComponent } from '../components/my-dialog/my-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Ability } from '@casl/ability';
import { AuthService } from 'src/app/core/services/auth.service';
import { v4 as uuidv4 } from 'uuid';
@Component({
  selector: 'app-elaborazione-water-supply-zone',
  standalone: true,
  imports: [
    CommonModule,
    MatDividerModule,
    MatProgressBarModule,
    MatStepperModule,
    ReactiveFormsModule,
    FormsModule,
    MatButtonModule,
    PageComponent,
    GoogleMapsModule,
    MyButtonComponent,
    FilesizePipe,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    CardComponent,
    InputTextComponent,
    MatTabsModule
],
  templateUrl: './elaborazione-water-supply-zone.component.html',
  styleUrl: './elaborazione-water-supply-zone.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ElaborazioneWaterSupplyZoneComponent {
  isLoading = signal(false);
  canSend = computed(() => this.selectedFile() !== undefined);
  canSendGeoTextArea = computed(() => this.geoJsonTextArea() !== undefined);
  canSendMKT = computed(() => this.textMKT() !== undefined);
  selectedFile: WritableSignal<any> = signal(undefined);
  geoJsonTextArea: WritableSignal<any> = signal(undefined);
  textMKT: WritableSignal<any> = signal(undefined);
  isCheckingElaborazione = signal(false);
  dragging = signal(false);
  createPermission: boolean = false;
  abilityDefined: boolean = false;
  isEmpty: boolean = true;
  showData = false
  firstFormGroup = this.fb.group({
    firstCtrl: ['', Validators.required],
  });
  secondFormGroup = this.fb.group({
    secondCtrl: ['', Validators.required],
  });
  insertForm: FormGroup;
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  center: google.maps.LatLngLiteral = { lat: 41.8992, lng: 12.5450 };
  zoom = 5.3;
  options: google.maps.MapOptions = {
    mapTypeId: 'roadmap',
/*     tilt: 0,
    clickableIcons: false,
    disableDefaultUI: true,
    disableDoubleClickZoom: true,
    zoomControl: true,
    scrollwheel: false,
    gestureHandling: 'auto',
    keyboardShortcuts: false,
    fullscreenControl: false,
    mapTypeControl: false,
    streetViewControl: false,  */
  };
   objGeoFromMkt = {
    "type": "Feature",
        "properties": {
        "fillColor": "red"
    },
        "geometry": {
          
 
        },

      
    }
  constructor(
    private router:Router,
    private dialogService: DialogService,
    private readonly service: WaterSupplyZoneService,
    private ref:ChangeDetectorRef,
    private readonly fb: FormBuilder,
    private ability: Ability,
    private authService: AuthService,
    public dialog: MatDialog,
    @Inject(SnackbarService) protected  readonly snackbar: SnackbarService,
  ) {
      this.insertForm = this.fb.group({
        nome: new FormControl('', [Validators.required]),
        myGeoJson: new FormControl('', ),
      });
      
   }
   ngOnInit(): void {
    this.authService.abilityDefined$.subscribe((abilityDefined) => {
      this.abilityDefined = abilityDefined;
      this.createPermission = this.ability.can('create', 'water-supply-zone');
      // Ora puoi fare altro dopo che l'abilità è stata definita
    });
  }

   openModalAdd(){
    const dialogRef = this.dialog.open(MyDialogComponent,
      {
        width: '70%',
        height: '70%',

      }
    )
    dialogRef.afterClosed().subscribe((el) => {
  
      if(el){
        this.loadGeoJson(el.datiGeoRef)
        var nomiFile= new Array()
        if( this.selectedFile()){
          nomiFile = this.selectedFile()
        }

        if(el.selectedFile){
          nomiFile.push(el.selectedFile)
          this.selectedFile.set(nomiFile)
          this.ref.detectChanges()
        }

      }
 
    })
   }
    isValidJSON(str:any){
    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  };
  convertMKT(data:any){
    Terraformer.parse(data)
    var geojson = wktToGeoJSON(data)
    console.log(geojson)
    this.objGeoFromMkt.geometry=geojson
    this.loadGeoJson(this.objGeoFromMkt)
  }


  
  loadGeoJson(data: any) {
    this.waitForMapInit().then(() => {
      console.log('Mappa pronta');

      if(this.isValidJSON(data)){
        data=JSON.parse(data)
      }
      console.log(data);
      
      if (!this.map?.googleMap) return;
  
      const mapInstance = this.map.googleMap;
      
      const newFeatures =  mapInstance.data.addGeoJson(data);

      mapInstance.data.setStyle((feature:any) =>{
   
          var color = feature.getProperty('fillColor');
          return {
              fillColor: color,
              strokeWeight: 1
          };
      });

   const bounds = new google.maps.LatLngBounds();

   newFeatures.forEach((feature: any) => {
    const customId = uuidv4()
    feature.setProperty('customFeatureId',customId);
    this.selectedFile()[this.selectedFile().length-1]['customFeatureId']=customId
    console.log(  this.selectedFile())
     const geometry = feature.getGeometry();

     geometry.forEachLatLng((latLng: google.maps.LatLng) => {
       bounds.extend(latLng);
     });
   });


   const center = bounds.getCenter();
   this.center = {
     lat: center.lat(),
     lng: center.lng(),
   };

    this.zoom = 10;
/*     newFeatures.forEach((feature: any) => {
      mapInstance.data.remove(feature);
    }); */
      this.ref.detectChanges()
     // this.insertForm.get("myGeoJson")?.setValue(data)
      
     this.showData=true

     
    });
  }
  
  deleteFeature(customId: any, index:any) {
    this.waitForMapInit().then(() => {
      
      if (!this.map?.googleMap) return;
  
      const mapInstance = this.map.googleMap;
  
      mapInstance.data.forEach((feature: google.maps.Data.Feature) => {
     
        const fid = feature.getProperty('customFeatureId');

        if (fid == customId) {
          if (!this.map?.googleMap) return;
          this.map.googleMap.data.remove(feature);
          const currentFiles = this.selectedFile();
          const updatedFiles = [...currentFiles];
          updatedFiles.splice(index, 1);
          this.selectedFile.set(updatedFiles);
          this.ref.detectChanges()
        }
      });
/*       this.map.googleMap.data.forEach((feature: google.maps.Data.Feature) => {
        if (!this.map?.googleMap) return;
        this.map.googleMap.data.remove(feature);
        this.ref.detectChanges()
      }); */
    });
  }
  

   waitForMapInit(){
    return new Promise((resolve) => {
      const checkMap = setInterval(() => {
        if (this.map && this.map.googleMap) {
          clearInterval(checkMap);
          resolve(null);
        }
      }, 100); 
    });
  };
  

  checkContent(event: Event) {
    const textareaValue = (event.target as HTMLTextAreaElement).value;
    this.isEmpty = textareaValue.trim().length === 0;
    if(!this.isEmpty){
      console.log(textareaValue)
      this.geoJsonTextArea.set(textareaValue)
    }
  }

  checkContentMKT(event: Event){
    const textareaValue = (event.target as HTMLTextAreaElement).value;
    this.isEmpty = textareaValue.trim().length === 0;
    if(!this.isEmpty){
      this.textMKT.set(textareaValue)
    }
  }

  resetForm() {
    this.selectedFile.set(undefined);
  }
  

  onSendWszGeojsonClick(){
    const mapInstance = this.map.googleMap;
    if(mapInstance){
      mapInstance.data.toGeoJson(el=>{
        this.insertForm.get("myGeoJson")?.setValue(el)
        this.service.invioJsonWsz(this.insertForm.value).subscribe((ell:any)=>{
          this.snackbar.success("Dati salvati con successo")
          this.resetForm()
          this.insertForm.reset()
          this.router.navigate(['water-supply-zone/'+ell.id])
        })
      })
    }


  }
  onSendClickTextArea(){
    this.loadGeoJson(this.geoJsonTextArea())
    this.showData=true
  }
  onSendClickMKT(){
    this.convertMKT(this.textMKT())
  }
  onSendClick() {
    if (this.canSend() === true) {
      this.dialogService.confirm('Trasmetti', `Stai per trasmettere questo file. I dati saranno storicizzati sui server di AnTeA.`, {
        label: 'Conferma',
        color: 'primary',
        icon: 'done',
        raised: true
      }).subscribe((result) => {
        if (result === true) {
          const reader = new FileReader();
          reader.readAsDataURL(this.selectedFile());
          reader.onload = async () => {
            const base64: any = reader.result?.toString().split(',')[1]
            const filePayload = {
              name: this.selectedFile().name,
              type: this.selectedFile().type,
              base64: base64,
            }
            this.service.sendFile(this.selectedFile()).subscribe((value) => {
              //this.dialogService.success('Il file è stato trasmesso ai server di AnTeA.', true);
              this.showData=true
              this.loadGeoJson(value)
           
              if(!value.error){
                //this.service.invioJsonWsz(value).subscribe(ell=>console.log(ell))
                // this.isCheckingElaborazione.set(true);
                //  this.startCheckingSaving(value.idElaborazione)
            
              }
             // this.resetForm();
             this.ref.detectChanges()
            })
          };
        }
      })
    }
  }

}
